import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  write (event) {
    const value = event.params.value
    if (value === undefined || value === null) return

    const eventName = event.params.event
    this.inputTargets.forEach((input) => {
      input.value = value
      if (!eventName) return

      input.dispatchEvent(new Event(eventName, { bubbles: true }))
    })
    this.markPressed(event.currentTarget)
  }

  markPressed (button) {
    if (!button || button.tagName !== 'BUTTON' || !button.hasAttribute('aria-pressed')) return

    const group = button.parentElement
    if (!group) return

    group.querySelectorAll('[aria-pressed]').forEach((item) => {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false')
    })
  }
}
